module.exports = __webpack_public_path__ + "Lato-SemiboldItalic.d5fa302ed37be6c20a88.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-SemiboldItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-SemiboldItalic.ttf
// module chunks = styles